<template>
  <div class="flex flex-col gap-6 p-4 sm:p-6">
    <section class="card">
      <MerchantUserPage :userApi="accountApi" />
    </section>

    <section class="card">
      <MerchantInfoEditCard :merchantTzApi="tzApi" />
    </section>

    <section class="card">
      <TzSettingCard :merchantTzApi="tzApi" />
    </section>

    <section class="card">
      <ChangePasswordPage :changePasswordApi="accountApi" />
    </section>

    <section class="card">
      <MerchantKeysPage :merchantKeysApi="merchantKeysApiImpl" />
    </section>

    <section class="card">
      <BlogPostPage :blogPostApi="blogApi" />
    </section>

    <section class="mb-10">
      <h3 class="text-gray-400 text-sm font-bold mb-4">危險區域</h3>

      <UserSecurityPanel :userSecurityApi="userSecurityApiImpl" @onLogoutRequired="handleAppLogout" />
    </section>

    <p class="text-sm text-gray-700">v0.0.0.16</p>
  </div>
</template>

<script setup lang="ts">
import {
  ChangePasswordPage, MerchantUserPage, UserSecurityPanel,
  MerchantKeysPage,
} from '@myorg/account-lib'
import { BlogPostPage } from '@myorg/blog-lib'
import { logger } from '@myorg/type-lib'
import { TzSettingCard, MerchantInfoEditCard } from '@myorg/menu-editor-lib'
import {
  blogApi, accountApi, tzApi,
  userSecurityApiImpl, merchantKeysApiImpl
} from '../composables/useUserServices'
import { useAuthFacade } from '@/auth/facade/authFacade'

// Authentication is now handled centrally by router guard
// No individual page-level authentication checks needed

const handleAppLogout = async () => {
  console.log('[UserPage.handleAppLogout] Logout required by security panel')
  const authFacade = useAuthFacade()
  await authFacade.logout()
  console.log('[UserPage.handleAppLogout] authFacade.logout() completed')
}
</script>